import { ICountryData, ICountry, ICountryConfigData, ICountryConfig } from "@/entities";
import { Country, CountryConfig } from "./country";

export const mockCountriesData = (): ICountryData[] => [
  {
    id: 1,
    name: "ESPAÑA",
    code: "ES",
  },
  {
    id: 2,
    name: "ARGENTINA",
    code: "AR",
  },
];

export const mockCountries = (data: ICountryData[] = mockCountriesData()): ICountry[] =>
  data.map((item) => new Country(item));

export const mockCountryConfigData = (): ICountryConfigData => {
  return {
    Orders: {
      Filter: {
        NextDays: 7,
        PreviousDays: 7,
      },
      Pickup: {
        DefaultStartTime: 8,
        MinimumRangeInHours: 2,
        DefaultFinalTime: 18,
        MinimumStartingIntervalInHours: 1,
        SuggestedFinishingIntervalInHours: 3,
        AllowIntervalTime: true,
        ForbiddenNextDay: {
          StartTime: "19:00",
          EndTime: "23:59",
        },
        EconoCash: {
          DefaultStartTime: 8,
          MinimumRangeInHours: 12,
          DefaultFinalTime: 20,
          MinimumStartingIntervalInHours: 12,
          SuggestedFinishingIntervalInHours: 12,
          AllowIntervalTime: true,
        },
      },
      Supply: {
        MaximumQuantity: 99,
      },
      Enabled: true,
      Delivery: {
        DefaultStartTime: 8,
        MinimumRangeInHours: 2,
        DefaultFinalTime: 18,
        MinimumStartingIntervalInHours: 1,
        SuggestedFinishingIntervalInHours: 3,
        AllowIntervalTime: true,
      },
      ShowWarning: false,
    },
    SearchEmployee: {
      Type: "Registry",
      Enabled: true,
      BarcodePostProcessorRegexPattern: "",
      SearchWithBarcode: true,
    },
    CashToday: {
      Enabled: true,
      ShowWarning: false,
    },
  } as ICountryConfig;
};

export const mockCountryConfig = (
  data: ICountryConfigData = mockCountryConfigData()
): ICountryConfig => new CountryConfig(data);
